import axios from 'axios';

const getAuthToken = () => {
  const token =
    localStorage.getItem('token') || sessionStorage.getItem('token');
  return token;
};

export const uploadSyllabus = async (courseId, file) => {
  const formData = new FormData();
  formData.append('courseId', courseId);
  formData.append('file', file);

  const response = await axios.post(
    '/api/courseSyllabus/uploadSyllabus',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const createDraftSyllabus = async (courseId, rows) => {
  const response = await axios.post(
    '/api/courseSyllabus/createDraft',
    { courseId, rows },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const getSyllabus = async (courseId) => {
  const response = await axios.get('/api/courseSyllabus/getSyllabus', {
    params: { courseId },
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  });
  return response.data;
};

export const addSyllabusRow = async (courseId, row) => {
  const response = await axios.post(
    '/api/courseSyllabus/addRow',
    { courseId, row },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const updateSyllabusRow = async (courseId, rowId, row) => {
  const response = await axios.post(
    '/api/courseSyllabus/updateRow',
    { courseId, rowId, row },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const deleteSyllabusRow = async (courseId, rowId) => {
  const response = await axios.post(
    '/api/courseSyllabus/deleteRow',
    { courseId, rowId },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const updateSyllabusSettings = async (courseId, settings) => {
  const response = await axios.post(
    '/api/courseSyllabus/updateSettings',
    { courseId, ...settings },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const updateSyllabusStatus = async (courseId, status) => {
  const response = await axios.post(
    '/api/courseSyllabus/updateStatus',
    { courseId, status },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const deleteSyllabus = async (courseId) => {
  const response = await axios.post(
    '/api/courseSyllabus/deleteSyllabus',
    { courseId },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const updateRowStatus = async (courseId, rowId, status) => {
  const response = await axios.post(
    '/api/courseSyllabus/updateRowStatus',
    { courseId, rowId, status },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const updateReadingStatus = async (
  courseId,
  rowId,
  readingId,
  status,
) => {
  const response = await axios.post(
    '/api/courseSyllabus/updateReadingStatus',
    { courseId, rowId, readingId, status },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};

export const generateReadings = async (courseId, rowId) => {
  const response = await axios.post(
    '/api/courseSyllabus/generateReadings',
    { courseId, rowId },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    },
  );
  return response.data;
};
